export default {
  setPaymentMethodsData(state, paymentMethods) {
    state.payments = paymentMethods;
  }
}
